let baseURL = ''
// let baseURL_dev = 'http://localhost:6200/' //本地
let baseURL_dev = 'https://cold.coldbaozhida.com/' //测试环境 http://coldtest.coldbaozhida.com:9999/
let baseURL_pro = 'https://cold.coldbaozhida.com/'//生产环境
let flag = process.env.NODE_ENV == 'development' ? true : false  //发布时打开


//是否在控制台显示请求日志，本地环境启用，打包环境禁用
let showHttpLog = false

baseURL = (flag ? baseURL_dev : baseURL_pro) + 'api/'//生产通用地址
baseURLGood = (flag ? baseURL_dev : baseURL_pro) + 'Cold_GoodsOrder'//生产订单
baseURLWork = (flag ? baseURL_dev : baseURL_pro) + 'Cold_WorkOrder'//生产工单系统
baseURLPush = (flag ? baseURL_dev : baseURL_pro) + 'ColdDataPush'//生产金卫信
//
baseURLColdMonitor = "https://cold.coldbaozhida.com/"//环动


// baseURLyunaiot = "https://yunaiot.baozhida.cn/API/"//物联智控
baseURLyunaiot = "https://cold.coldbaozhida.com/Cold_Monitor_AOIT/"//物联智控

module.exports = {
	baseURLPush: baseURLPush,
	baseURL: baseURL,//通用地址
	baseURLColdMonitor: baseURLColdMonitor,//环动
	baseURLyunaiot: baseURLyunaiot,//物联智控
	baseURLGood: baseURLGood,//订单专用
	baseURLWork: baseURLWork,//工单系统
	showHttpLog: showHttpLog
}
